/**
 * Recovery for tabs left open across a deploy: they still reference the
 * previous build's chunks, which no longer exist. Vite reports a chunk or CSS
 * that fails to load as `vite:preloadError`, so reload to pick up the new
 * build — unless this tab reloaded for the same reason within the last
 * minute, so that a failure the reload doesn't fix (a blocked network, a
 * missing file) surfaces as before instead of looping. A one-off failure
 * therefore doesn't use up the recovery for a later deploy.
 */
const RELOADED_AT_KEY = "aqora_preload_error_reloaded_at";
const RELOAD_GUARD_MILLIS = 60_000;

export function reloadOnPreloadError(context: Window = window) {
  context.addEventListener("vite:preloadError", () => {
    const now = Date.now();
    try {
      const reloadedAt = Number(
        context.sessionStorage.getItem(RELOADED_AT_KEY),
      );
      if (now - reloadedAt < RELOAD_GUARD_MILLIS) return;
      context.sessionStorage.setItem(RELOADED_AT_KEY, String(now));
    } catch {
      // Without storage there is no guard against a reload loop.
      return;
    }
    context.location.reload();
  });
}
